import React, { useEffect, useState } from "react";
import { usePhrase } from "@/contexts/LanguageContext";
import { api, formatINR } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";

const statusStyle = {
  "Potential Match": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Partial Match": "bg-amber-100 text-amber-800 border-amber-200",
  "More Information Required": "bg-slate-100 text-slate-700 border-slate-200",
  "Not Matched": "bg-red-50 text-red-700 border-red-200",
};

export default function SchemeMatches() {
  const pt = usePhrase();
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      const b = await api.get("/businesses"); const biz = b.data[0]; if (!biz) return setLoading(false);
      const { data } = await api.get(`/businesses/${biz.id}/scheme-matches`);
      setMatches(data);
      setLoading(false);
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="scheme-matches-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 brand-heading">{pt("Scheme Matches")}</h1>
        <p className="text-slate-600 mt-1 text-sm">{pt("Central and Madhya Pradesh schemes potentially applicable to your business.")}</p>
      </div>
      {loading ? <div className="text-slate-500">{pt("Matching schemes…")}</div> : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {matches.map((m) => (
            <div key={m.scheme_id} className="p-6 rounded-lg border border-slate-200 bg-white card-hover" data-testid={`sch-match-${m.scheme_code}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="font-semibold text-slate-900 brand-heading leading-snug">{m.scheme_name}</div>
                <span className={`shrink-0 text-[10px] font-semibold uppercase px-2 py-0.5 rounded-full border ${statusStyle[m.status] || "bg-slate-100 border-slate-200"}`}>{pt(m.status)}</span>
              </div>
              <div className="text-xs text-slate-500 mt-1">{pt(m.scheme_type)}</div>
              <p className="text-sm text-slate-700 mt-3 leading-relaxed">{pt(m.benefit_type)}</p>
              <div className="mt-3 text-xs">
                <div className="text-slate-500">{pt("Max cap:")} <span className="font-semibold text-slate-800">{formatINR(m.max_benefit_amount)}</span></div>
                <div className="text-slate-500 mt-1">{pt("Match:")} <span className="font-semibold text-slate-800">{m.match_percentage}%</span></div>
              </div>
              <div className="mt-3 space-y-1">
                {(m.matched || []).slice(0, 3).map((c) => <div key={c} className="text-xs text-emerald-700">✓ {c}</div>)}
                {(m.unmatched || []).slice(0, 3).map((c) => <div key={c} className="text-xs text-orange-700">! {c}</div>)}
              </div>
              <div className="mt-3 text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-md p-2">{pt("Scheme matching is preliminary. Eligibility and assistance are determined by the competent department and participating lender.")}</div>
            </div>
          ))}
        </div>
      )}
      <DisclaimerBanner compact />
    </div>
  );
}
